import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'
import {API_URL} from '@/consts'
import {useQuery} from 'react-query'
import {types} from './types'

export const doc = documentComponent({
  name: 'TypeaheadPurposely',
  description: 'Typeahead built for a listed resource from Purposely Django Rest Framework API.',
  categories: ['DRF', 'form'],
  // inline: true,
  props: t.object({
    name: t.string(),
    value: t.any('value'),
    setValue: t.fn([t.any('new-value')]),
    hasError: t.boolean().optional(),
    compact: t.boolean().optional(),
    type: t.choice(Object.keys(types))
  }),
  examples: {
    name: {
      props: {
        name: 'example',
        value: null,
        setValue: (value) => { console.log('setValue', value) },
        type: 'adminNonprofit'
      },
      description: 'Nonprofits select'
    }
  },
  todo: [],
})
